import moment from 'moment'
import antLocaleFrFr from 'antd/es/locale/fr_FR'
import antLocaleEnGb from 'antd/es/locale/en_GB'
import antLocaleEsEs from 'antd/es/locale/es_ES'
import antLocaleItIt from 'antd/es/locale/it_IT'
import antLocaleSvSe from 'antd/es/locale/sv_SE'
import antLocaleNbNo from 'antd/es/locale/nb_NO'
import antLocaleFiFi from 'antd/es/locale/fi_FI'
import antLocalePtPt from 'antd/es/locale/pt_PT'

import 'moment/locale/fr'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/es'
import 'moment/locale/sv'
import 'moment/locale/nb'
import 'moment/locale/fi'
import 'moment/locale/pt'
//import loadTranslations from '../../locales'

export const GET_LANG_BEGIN = 'GET_LANG_BEGIN'
export const GET_LANG_SUCCESS = 'GET_LANG_SUCCESS'
export const GET_LANG_ERROR = 'GET_LANG_ERROR'

export const getLangsBegin = () => ({
  type: GET_LANG_BEGIN
})

export const getLangsSuccess = dataLang => ({
  type: GET_LANG_SUCCESS,
  dataLang
})

export const getLangsError = error => ({
  type: GET_LANG_ERROR,
  error
})

export const getLang = intlId => dispatch => {
  dispatch(getLangsBegin())

  //let messages = null
  let locale = null
  let defaultLocale = null
  let antLocale = null

  switch (intlId) {
    case 'fr-FR':
      locale = 'fr'
      defaultLocale = 'fr'
      moment.locale('fr')
      antLocale = antLocaleFrFr
      //messages = loadTranslations('es')
      break
    case 'es-ES':
      locale = 'es'
      defaultLocale = 'es'
      moment.locale('es')
      antLocale = antLocaleEsEs
      //messages = loadTranslations('es')
      break
    case 'it-IT':
      locale = 'it'
      defaultLocale = 'it'
      moment.locale('it')
      antLocale = antLocaleItIt
      //messages = loadTranslations('it')
      break
    case 'sv-SE':
      locale = 'sv'
      defaultLocale = 'sv'
      moment.locale('sv')
      antLocale = antLocaleSvSe
      break
    case 'nb-NO':
      locale = 'nb'
      defaultLocale = 'nb'
      moment.locale('nb')
      antLocale = antLocaleNbNo
      break
    case 'fi-FI':
      locale = 'fi'
      defaultLocale = 'fi'
      moment.locale('fi')
      antLocale = antLocaleFiFi
      break
    case 'pt-PT':
      locale = 'pt'
      defaultLocale = 'pt'
      moment.locale('pt')
      antLocale = antLocalePtPt
      break
    case 'en-GB':
    default:
      locale = 'en'
      defaultLocale = 'en'
      moment.locale('en')
      antLocale = antLocaleEnGb
    //messages = loadTranslations('en')
  }

  const dataLang = {
    intlId,
    locale,
    defaultLocale,
    antLocale
    //messages
  }

  const call = () => {
    dispatch(getLangsSuccess(dataLang))
  }

  setTimeout(call, 500)
}
